import { StyledRadio } from '@/components/styles'
import { useFormContext } from 'react-hook-form'

const Radio = props => {
  const { name, value, defaultChecked, children = [] } = props
  const { register } = useFormContext()
  const id = `${name}-radio-${value}`

  return (
    <StyledRadio>
      <StyledRadio.Input
        id={id}
        type="radio"
        name={name}
        value={value}
        ref={register}
        defaultChecked={defaultChecked}
      />
      <StyledRadio.Label htmlFor={id}>{children}</StyledRadio.Label>
    </StyledRadio>
  )
}

export default Radio
